<template>
    <v-app>
		<template v-if="!getAuth.isChecked"> 
       		<LayoutBootstrap />
		</template>
		<template v-if="getAuth.isChecked"> 
			<LayoutLogin v-if="!getAuth.isSigned"/>
			<LayoutDashboard v-if="getAuth.isSigned"/>
		</template> 
    </v-app>
</template>

<script>
    import LayoutBootstrap from "@/layouts/bootstrap"; 
    import LayoutLogin from "@/layouts/login"; 
    import LayoutDashboard from "@/layouts/dashboard"; 

    export default {
        name: 'App',

        components: {
            LayoutBootstrap,  
            LayoutLogin,  
            LayoutDashboard, 
        },

        data: () => ({ 
		}),
		created(){ 
			this.$store.dispatch("a_authCheckSigned")
		},
		methods:{ 
		},
		computed:{
			getAuth(){
				return this.$store.getters.getAuth;
			}
		}
    };
</script>


<style lang="less">
	.v-input.v-input--is-focused svg.white--text path{
		transition: all .3s;
		fill : #aaa;
	}
</style>